import { EmergencyNotificationConfiguration } from '@dreryk/egabinet-emergency-notification-frontend-api';

import { Heading, SecondaryText, StyledFlex, Toggle } from '@dreryk/react-components';
import { FormContextValues } from '@dreryk/react-common';

import { translationKeys } from '../../../translations';

import { EmergencyNotificationConfigurationEnabledFieldFormBeanPart } from './EmergencyNotificationConfigurationEnabledField.types';

type EmergencyNotificationConfigurationEnabledFieldProps = Pick<
   FormContextValues<EmergencyNotificationConfigurationEnabledFieldFormBeanPart>,
   'register' | 'watch'
> & {
   readonly emergencyNotificationConfiguration: EmergencyNotificationConfiguration;
};

export const EmergencyNotificationConfigurationEnabledField = (
   props: EmergencyNotificationConfigurationEnabledFieldProps
): JSX.Element => {
   const defaultValue = Boolean(
      props.emergencyNotificationConfiguration.smsConfiguration.enabled ||
         props.emergencyNotificationConfiguration.inAppConfiguration.enabled
   );

   return (
      <StyledFlex gap={'12px'} alignItems={'start'}>
         <Toggle
            testId={'configurationEnabled'}
            controller={props.register('configurationEnabled')}
            defaultValue={defaultValue}
         />
         <StyledFlex direction={'column'}>
            <Heading testId={'silentAlarmSOS'} type={'h2'} content={translationKeys.silentAlarmSOS} margin={'0px'} />
            <SecondaryText testId={'allowsSilentAlarmSOS'} text={translationKeys.allowsSilentAlarmSOS} />
         </StyledFlex>
      </StyledFlex>
   );
};
